export default {
  collectionDetails: (state) => state.collectionDetails,
  collections: (state) => state.collections,
};
